module.exports = __webpack_public_path__ + "img/email_icon_selected_mobile.f874c4c8.svg";